const TRANSLATION = {
  buyModal: {
    afterFree: 'După perioada ta de probă gratuită',
    btn: 'Încercați gratuit',
    freeTrial: 'Proba gratuită de 3 zile',
    monthLabel: 'lună',
    selectLabel: 'Selectați un plan',
    title: 'Plan de Abonament',
    yearLabel: 'an',
  },
  contact: {
    block1:
      'Pentru personalizări, întrebări sau sugestii, vă rugăm să ne contactați la adresa contact@noam.tools. Vom răspunde în mod prompt.',
    block2: 'Sprijiniți-ne prin evaluarea noastră în magazinul Google Apps Extension cu ★★★★★.',
    block3: 'Ajutați ceilalți prin partajarea acestei extensii:',
    title: 'Contactați-ne',
  },
  help: {
    AquickOverviewOfNoam: 'O prezentare rapidă a lui Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Gestionarea favoritei',
    Fixedplugin: 'Plugin Fixat',
    Focusing: 'Concentrarea',
    Free: 'Gratuit',
    FreeTrialBenefits: 'Beneficii ale versiunii de proba gratuită',
    GoWithWikipedia: 'Mergeți cu Wikipedia',
    GoWithYouTube: 'Folosește YouTube',
    HoverTranslation: 'Traducere prin hover',
    Howtouse: 'Cum se folosește',
    ImageTranslation: 'Traducere de imagini',
    InstantTranslation: 'Traducere Instantanee',
    Membership: 'Membru',
    NoamHelp: 'Noam te ajută să traduci și să rezumi',
    PDFparallelTranslation: 'Traducere Paralelă PDF',
    ParallelTranslation: 'Traducere Paralelă',
    SkipAllSteps: 'Sari peste toate pașii',
    Summary: 'Rezumat',
    Translation: 'Traducere',
    TryItForFree: 'Încercați gratuit',
    Video: 'Video',
    VideoSummary: 'Rezumat video',
    VideoTranslation: 'Traducere video',
    WebSummary: 'Rezumat Web',
    WordSelectionTranslation: 'Selecție de cuvinte pentru traducere',
    benefits: 'Avem beneficii care te așteaptă!',
    dayFree: 'Proba gratuită de 3 zile',
    done: 'Gata',
    next: 'Următorul',
    pin: 'Fixează Noam pentru acces mai ușor～～',
    planIsNotExist: 'Planul nu este disponibil',
    startWiki: 'Să începem cu Wikimedia!',
    startYoutube: 'Să începem cu YouTube!',
    try: 'Încercați-l',
    tryNow: 'Încearcă acum!',
  },
  home: {
    PDFTranslate: {
      desc: 'Traducere bilingvă + Chat PDF',
      sub1: {
        desc: 'Citirea bilingvă permite compararea textului original și a traducerii unul lângă celălalt, sporind eficiența citirii.',
        title: 'Citire bilingvă',
      },
      sub2: {
        desc: 'AI analizează și rezumă, și poate răspunde la întrebările tale pe baza conținutului PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Traducere PDF puternicută de AI pentru o precizie și eficiență mai mari.',
        title: 'Precizie și Eficiență',
      },
      title: 'Traducere PDF',
    },
    aiAssistant: {
      desc: 'Renderea Traducerii Web Mai Inteligente și Mai Convenientă',
      panel1: {
        desc: 'Traducerile bilingve cu referințe cruzate vă ajută să comparați textul original cu traducerea, astfel încât să puteți înțelege mai bine și să vă îmbunătățiți eficiența de citire.',
        title: 'Traducere bilingvă',
      },
      panel2: {
        left: {
          desc: 'Când navigați pe o pagină web, plasați cursorul peste conținutul pe care doriți să îl traduceți pentru a vedea traducerea.',
          title: 'Traducere pe hover',
        },
        right: {
          desc: 'Când navigați pe o pagină web, selectați textul pe care doriți să îl traduceți pentru a vedea traducerea.',
          title: 'Traducere a Selecției de Text',
        },
      },
      panel3: {
        one: {
          desc: 'Traduceți și rezumați pagini web și conținut video oriunde, în orice moment, pentru o experiență mai fluidă!',
          title: 'Click și Selectează',
        },
        three: {
          desc: 'Modelul de limbaj mare condus de AI asigură precizia și consistența traducerii pentru o experiență de citire îmbunătățită.',
          title: 'Condus de AI',
        },
        two: {
          desc: 'Acoperire completă în mai multe limbi, citire bilingvă fără bariere, traducere cu un singur clic - experimentați diferența!',
          title: 'Mai cuprinzător și convenabil',
        },
      },
      panel4: {
        tab1: {
          desc: 'Expertul tău în eficiență - folosind ChatGPT, Noam traduce și rezumă conținutul video de pe YouTube pentru a-ți economisi timp!',
          key: 'Video',
          title: 'Traducere și Rezumat Video',
        },
        tab2: {
          desc: 'Click pentru a traduce imagini în timpul navigării pe web.',
          key: 'Imagine',
          title: 'Traducere Imagini',
        },
        tab3: {
          desc: 'Extrage instantaneu informațiile cheie din paginile web și oferă un rezumat, sporind eficiența lecturii tale.',
          key: 'Web',
          title: 'Traducere și Rezumat Web',
        },
        tag1: 'Simplu',
        tag2: 'Eficient',
        tag3: 'Ușor de înțeles',
      },
      title: 'Asistent AI',
    },
    getStart: 'Începeți',
    getStartedForFree: 'Începeți gratuit',
    howItWork: {
      desc: 'Noam integrează modele AI pentru a oferi utilizatorilor o experiență inteligentă de traducere și rezumare a paginilor web între limbi, traducere de PDF și imagini, traducere și rezumare de videoclipuri',
      title: 'Cum funcționează',
    },
    lastBlock: { desc: 'Traducere AI mai bună pentru o experiență de citire mai fluidă' },
    top: {
      desc: 'Noam este o extensie gratuită de browser AI care te ajută să traduci și să rezumezi pagini web, videoclipuri și conținut PDF.\n      Alătură-te Noam și experimentează magia!',
      title1: 'O Magie',
      title2: 'Un Singur Click',
    },
    userReviews: {
      desc: 'Recenzii cu cinci stele pe Chrome Web Store',
      title: 'Recenzii ale Utilizatorilor',
    },
  },
  installTips: {
    btn: 'Încercați-l acum',
    text: 'Instalați „Noam Browser Plugin” pentru a debloca mai multe funcții! Cross-referințe web,\n    rezumate video web și multe altele!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amharică',
    ar: 'arab',
    as: 'asameză',
    auto: 'Detectare automată',
    az: 'azerbeijanesc',
    ba: 'bașkir',
    bg: 'bulgar',
    bn: 'Bangla',
    bo: 'tibetan',
    bs: 'bosniac',
    ca: 'catalan',
    cs: 'ceh',
    cy: 'galez',
    da: 'danese',
    de: 'german',
    dsb: 'sorab de jos',
    dv: 'divehi',
    el: 'grecesc',
    en: 'Engleză',
    es: 'spaniolă',
    et: 'estonian',
    eu: 'basc',
    fa: 'persian',
    fi: 'finlandez',
    fil: 'filipinez',
    fj: 'fijian',
    fr: 'Franceză',
    frCA: 'Franceză (Canada)',
    ga: 'irlandez',
    gl: 'galician',
    gom: 'konkani',
    gu: 'gujarati',
    ha: 'hausa',
    he: 'ebraică',
    hi: 'hindi',
    hr: 'croată',
    hsb: 'sorab superior',
    ht: 'Creol haitian',
    hu: 'ungurească',
    hy: 'armenian',
    id: 'indonezian',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandez',
    it: 'italian',
    iu: 'inuktitut',
    iuLatn: 'Inuktitut (Latin)',
    ja: 'japonez',
    ka: 'georgian',
    kk: 'kazah',
    km: 'khmer',
    kmr: 'Curdo (de Nord)',
    kn: 'Kannada',
    ko: 'coreean',
    ku: 'Curdo (Central)',
    ky: 'kirghiz',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'lituanian',
    lug: 'Gând',
    lv: 'latvian',
    lzh: 'Chineză (Literară)',
    mai: 'Maithili',
    mg: 'malgaș',
    mi: 'maori',
    mk: 'macedonean',
    ml: 'malayalam',
    mnCyrl: 'mongol (cirilic)',
    mnMong: 'mongol (Tradicional)',
    mr: 'marathi',
    ms: 'malay',
    mt: 'maltéz',
    mww: 'Hmong Daw',
    my: 'Myanmar (birmaneză)',
    nb: 'norvegian',
    ne: 'nepalian',
    nl: 'neerlandeză',
    noSearchLang: 'Limba nu este acceptată',
    nso: 'Sesotho de nord',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Otomi din Querétaro',
    pa: 'punjabi',
    pl: 'polonez',
    placeholder: 'Căutare',
    prs: 'Dari',
    ps: 'pasto',
    pt: 'Portugheză (Brazilia)',
    ptPT: 'Portugheză (Portugalia)',
    ro: 'română',
    ru: 'rusesc',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindhi',
    si: 'sinhaleză',
    sk: 'slovac',
    sl: 'sloven',
    sm: 'samoan',
    sn: 'Shona',
    so: 'somaliano',
    sq: 'albanez',
    srCyrl: 'sârbă (cirilic)',
    srLatn: 'sârbă (latină)',
    st: 'sesotho',
    sv: 'suedez',
    sw: 'swahili',
    ta: 'tamil',
    te: 'telugu',
    th: 'thailandez',
    ti: 'tigrinya',
    tk: 'turkmen',
    tlhLatn: 'Klingon (Latin)',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'setswana',
    to: 'tongan',
    tr: 'turc',
    tt: 'tătar',
    ty: 'tahitian',
    ug: 'Uighur',
    uk: 'ucrainean',
    ur: 'urdu',
    uz: 'uzbecă (latină)',
    vi: 'vietnamez',
    xh: 'xhosa',
    yo: 'yoruba',
    yua: 'mayă yucatecă',
    yue: 'Cantonéz (Tradicional)',
    zh: 'chinez',
    zhHans: 'Chineză Simplificată',
    zhHant: 'Chineză tradițională',
    zu: 'zulu',
  },
  login: {
    and: 'și',
    btn: 'Conectare cu Google',
    btn1: 'Conectați-vă acum',
    desc: 'Conectați-vă pentru a debloca mai multe experiențe',
    policy: 'Politica de Confidențialitate',
    terms: 'Termeni de Utilizare',
    tips: 'Prin înregistrare, sunt de acord cu',
    title: 'Bine ați venit la Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Urmărește', twitter: 'Twitter' },
    legal: {
      policy: 'Politica de Confidențialitate',
      terms: 'Termeni de Serviciu',
      title: 'Legal',
    },
    product: {
      image: 'Traducere de Imagine',
      pdf: 'Traducere PDF',
      title: 'Produse',
      video: 'Traducere și Rezumat Video',
      web: 'Traducere și Rezumat Web',
    },
    resources: { title: 'Resurse' },
    tools: { title: 'Instrumente', pdf: 'Traducere PDF' },
  },
  pageHeader: {
    contact: 'Contact',
    help: 'Ajutor',
    logout: 'Deconectare',
    logoutSucc: 'Deconectat.',
    pricing: 'Prețuri',
    settings: 'Setări',
    signUp: 'Autentificare',
  },
  pdf: {
    autoDetect: 'Auto-detectare',
    cancelBtn: 'Anulați',
    cancelUpload: 'Anulați',
    chatPdf: {
      summaryError: 'Rezumatul a eșuat, vă rugăm să încercați din nou mai târziu',
      chatError: 'Chatul a eșuat, vă rugăm să încercați din nou mai târziu',
      Search: 'Căutare',
      cancel: 'Anulați',
      chatTitle: 'Bine ați venit la Noam! Iată un rezumat al PDF-ului dvs.:',
      clear: 'Clar',
      clearContent:
        'Acest lucru va începe o nouă conversație. Conversația curentă nu va fi salvată. Sunteți sigur?',
      clearDialogTitle: 'Vă rugăm să confirmați',
      clearSucc: 'Eliberat',
      copy: 'Copiază',
      copySucc: 'Copiat',
      delete: 'Șterge',
      deleteCancel: 'Anulați',
      deleteContent: 'Acest fișier PDF nu poate fi recuperat după ștergere. Sunteți sigur?',
      deleteOk: 'Șterge',
      deleteSuccess: 'Șters',
      deleteTitle: 'Confirmă Ștergerea',
      expand: 'Colaps',
      historyTitle: 'Istorie',
      listError:
        'Nu s-a putut încărca lista de citit. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
      loading: 'Încărcare...',
      noDataDesc: 'Încă nu există istoric.',
      noMore: 'Nu mai există conținut.',
      placeholder: 'Întrebă orice despre acest PDF',
      summaryTitle: 'Poate că vă interesează aceste întrebări:',
    },
    collectionEmpty: 'Colecția ta este goală.',
    collectionTab: 'Note',
    dataLoading: 'Se încarcă...',
    dialogContent: 'Ești sigur că vrei să ștergi asta?',
    dialogTitle: 'Vă rugăm să confirmați',
    download: {
      both: 'Bilingv',
      btn: 'Salvați',
      cancel:
        'Închiderea acestei ferestre va anula descărcarea PDF-ului. Sunteți sigur că doriți să anulați?',
      desc: 'Salvare pe dispozitiv: Descarcă traducerile ca imagini; Salvare și imprimare: Descarcă traducerile în formatul original, cu suport pentru copiere.',
      download: 'Descărcare',
      downloadMsg1: 'Progresul traducerii PDF:',
      downloadMsg2: 'Timp ramas estimat:',
      downloadSucc: 'PDF-ul este gata! Click pentru a salva.',
      downloadTip:
        'Se descarcă fișierul PDF. Nu închideți această fereastră pentru a evita erori de descărcare.',
      error: 'Nu s-a putut salva. Încercați în schimb să imprimați.',
      fileName: 'Nume fișier:',
      fileType: 'Tip fișier:',
      loading: 'Se salvează...',
      loading2: 'Se încarcă...',
      minute: 'Minute...',
      msg1: 'Unele traduceri din acest document sunt mai lungi decât textul original și se pot suprapune în fișierul descărcat. Recomandăm citirea pe pagină web.',
      msg2: 'Traducerea nu este încă completă. Vă rugăm să descărcați după ce traducerea este finalizată.',
      msg3: '2. Unele traduceri sunt prea lungi. Citiți pe pagina web pentru a evita suprapunerea textului.',
      msg4: 'Sarcinile de traducere sunt în curs de procesare. Vă rugăm să încercați din nou după finalizarea lor.',
      progress: 'Traducere PDF. Progres: {{progress}}, Timp estimat rămas: {{minutes}} minute...',
      save: 'Salvează pe dispozitiv',
      savePrint: 'Salvare și imprimare',
      success: 'Descărcat',
      trans: 'Doar traducere',
      transContinue: 'Continuă traducerea',
    },
    downloadBtn: 'Descărcare',
    dragTipModal: {
      black: 'spațiu',
      leftKey: 'butonul stâng',
      ok: 'Am înțeles',
      press: 'Presă',
      tips: 'a trage și vizualiza',
    },
    entry: 'PDF-uri',
    fileErrMsg:
      'Citirea fișierului a eșuat. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    fileMsg: 'Dimensiunea actuală a fișierului:',
    fileMsg2: 'Vă rugăm să încărcați un fișier mai mic de 300MB.',
    freeBannerBtn: 'Actualizare',
    freeBannerTips: 'Limita de traduceri PDF gratuite a fost atinsă',
    guide: {
      placeholder: 'Lipiți link-ul PDF aici',
      start: 'Începeți traducerea',
      text1: 'Citare bilingvă',
      text2:
        'Citește bilingv pentru a compara textul original și traducerea unul lângă altul, îmbunătățind eficiența ta.',
      text3: 'Conversează cu PDF-ul tău',
      text4:
        'Analiză și rezumare bazată pe AI. Pune întrebări despre PDF-ul tău și primește răspunsuri instantanee.',
      text5: 'Precis și Eficient',
      text6: 'Traducere PDF puternicută de AI pentru o precizie și eficiență mai mari.',
      title1: 'Traducere bilingvă',
      title2: 'Conversează cu PDF-ul tău',
      toast: 'Vă rugăm introduceți un link PDF online valid care se termină cu .pdf',
    },
    hasTransTask: 'O sarcină de traducere este în curs de desfășurare. Vă rugăm să așteptați.',
    hoverTrans: 'Paragrafele de Traducere prin Suprapunere',
    initial: 'Traduceți PDF',
    installText: 'Soluția ta completă pentru traducerile zilnice.',
    installText2: 'Vă rugăm să instalați mai întâi extensia',
    installTips:
      'Instalați extensia pentru mai multe traduceri PDF și traduceri mai fluide ale site-urilor web:',
    kw: 'agrafă',
    link: 'link',
    listError:
      'Eșec la încărcarea fișierelor PDF. Vă rugăm să încercați din nou mai târziu sau contactați suportul tehnic.',
    memoTotalCount: 'Total 1 articol',
    new: 'fișier nou',
    noId: 'ID fișier nu a fost găsit.',
    notPdf: 'Doar fișiere PDF.',
    okBtn: 'Șterge',
    okBtn2: 'Am înțeles',
    original: 'Original',
    parallel: 'Paralel',
    parseErrDialogContent:
      'Acest link PDF nu poate fi tradus direct. Te rugăm să descarci PDF-ul și să-l încarci pentru traducere.',
    parseErrTips: 'Nu s-a putut analiza fișierul',
    parseFileToast:
      'Eșec la parsarea fișierului. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    pdfLoading: 'Analiză...',
    searchPlaceholder: 'Căutare',
    selectTrans: 'Selectați textul de tradus',
    shareBtn: 'Partajați',
    shareBtnText1: 'Generați Link de Partajare',
    shareBtnText2: 'Actualizează Conținutul Partajat',
    shareModal: {
      cancel: 'Anulați',
      copy: 'Copiați',
      copySucc: 'Link copiat',
      custom: 'Personalizați:',
      errMsg:
        'Conținutul selectat nu a fost încă tradus complet. Vă rugăm să traduceți înainte de a partaja.',
      gen: 'Partaja',
      modify: 'Editați',
      notSupport: 'Această limbă nu este suportată în prezent.',
      page: 'Pagini',
      pageNuErr: 'Vă rugăm introduceți un număr de pagină valid.',
      range: 'Domeniu de aplicare:',
      remain: 'rămase',
      remain1: 'Timp total estimat:',
      search: 'Căutare',
      settings: 'Setări de partajare:',
      shareSetting: 'Setări de partajare',
      shareText: 'Partajați',
      shareTips: 'Partajați link-ul PDF tradus cu prietenii voștri:',
      sourceLang: 'De la:',
      target: 'Către:',
      text1: 'Setări de partajare',
      text2: 'Generați Link de Partajare',
      totalPage: '1 pagină în total',
      trans: 'Traduce',
      translateTips:
        'Sfat: Dacă traducerea durează ceva timp, puteți închide această fereastră și partajați mai târziu.',
      translating: 'Se traduce fișierul PDF...',
      update: 'Actualizează Link de Partajare',
    },
    shareMsg1: 'Link de partajare generat.',
    shareMsg2: 'Conținutul partajat a fost actualizat.',
    shareMsg3:
      'Nu s-a putut genera link-ul de partajare. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    shareMsg4:
      'Actualizarea conținutului partajat a eșuat. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    shareTips: 'Traducerea PDF-ului tău este gata! Partajeaz-o cu prietenii tăi.',
    start: 'Începeți perioada de proba gratuită',
    thumbnail: 'Cuprins',
    toast1: 'Se încarcă PDF. Încercați din nou mai târziu.',
    toast2: 'Conținutul PDF este în curs de procesare. Dialogul nu este suportat în prezent.',
    toast3: 'Se descarcă. Vă rugăm să încercați din nou după ce descărcarea este finalizată.',
    toolbar: { Adjust: 'Ajusta', autoFit: 'Auto-Ajustare' },
    trans: 'Traducere',
    transSucc: 'Traducere reușită!',
    unLoginToast: 'Vă rugăm să vă autentificați pentru a folosi această funcție.',
    uploadBtn: 'Încărcare',
    uploadErr:
      'Încărcarea fișierului a eșuat. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    uploadErrSignUrl:
      'Nu s-a putut obține URL-ul de încărcare. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    uploadMsg1: 'Trageți și plasați fișierul aici.',
    uploadMsg2: 'Tipuri de fișiere acceptate: PDF  |  Dimensiune maximă a fișierului: 300MB',
    uploadMsg3: 'Faceți clic pentru a selecta sau trageți și plasați fișierele aici.',
    uploading: 'Încărcare',
    uploadingMsg: 'Se încarcă. Vă rugăm să așteptați.',
    uploadingMsg1: 'Fișierul se încarcă. Vă rugăm să încercați din nou mai târziu.',
    uploadingMsg2: 'Un fișier este în prezent convertit. Vă rugăm să încercați din nou mai târziu.',
    uploadingMsg3:
      'Cererea de progres de conversie a eșuat. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    uploadingMsg4:
      'Noam nu poate accesa fișierele locale. Te rog să încarci manual un fișier PDF pentru traducere.',
    uploadingMsg5:
      'Nu s-a putut recupera URL-ul fișierului. Vă rugăm să încercați din nou mai târziu sau să contactați suportul tehnic.',
    video: 'video',
    vipBannerBtn: 'Actualizare',
    vipBannerTips: 'Ați atins limita de traducere PDF pentru acest lună.',
    webTrans: 'Referință completă întreagă',
  },
  pricing: {
    FAQ: 'Întrebări frecvente',
    FQAObj: {
      a1: 'Da, Noam oferă un plan gratuit pe care îl puteți folosi imediat.',
      a2: 'Oferim trei planuri de membru: Pro, Pro+ și Enterprise. Puteți alege să plătiți lunar sau anual. Facturarea anuală oferă economii semnificative.',
      a3: 'Toate funcționalitățile sunt disponibile în ambele planuri. Diferența principală este costul: abonamentele anuale costă mai puțin în total. Abonamentele lunare sunt facturate în fiecare lună, în timp ce planurile anuale sunt facturate o dată pe an.',
      a4: 'Puteți anula abonamentul dvs. în orice moment în Setările contului.',
      q1: 'Există un plan gratuit?',
      q2: 'Ce planuri de prețuri și opțiuni de plată sunt disponibile?',
      q3: 'Care este diferența între abonarea lunară și cea anuală?',
      q4: 'Cum anulez abonamentul meu?',
    },
    around: 'În jurul',
    billedMonthly: 'Facturat lunar',
    billedYearly: 'Facturat anual',
    day: 'zi',
    desc: 'Comparați Planurile și Alegeți Cel Mai Bun',
    detailedCompare: 'Comparați Planurile',
    discount: '20% reducere',
    enterprise: {
      benefit1: 'Suport Clienți Prioritar',
      benefit2: 'Utilizatori Mulți',
      benefit3: 'Soluții Adaptate',
      benefit5: 'Manager de Cont Deditat',
      btn: 'Contactați-ne',
      recommendText: 'Planuri personalizate (≥3 persoane)',
      talkToUs: 'Contactați-ne',
    },
    free: {
      benefit1: 'Traducere instantanee 100 de ori/zi',
      benefit2: 'Traducere și Rezumat de Site Web',
      benefit3: '30 Traduceri de Imagini',
      benefit4: 'Traducere și Rezumat Video',
      benefit5: '10 Traduceri PDF',
      benefit6: '5.000 de tokenuri',
      btn: 'Încercă gratuit',
      recommendText: 'Proba gratuită',
    },
    imageTranslation: 'Traducere de Imagine',
    month: 'lună',
    monthly: ' lunar',
    pageTitle: 'Prețuri',
    pdf: {
      chat: 'Interogări de Chat PDF',
      maxPage: 'Pagini maxime per PDF',
      translation: 'Traducere PDF',
    },
    preMonth: 'Pe lună',
    pro: {
      benefit1: 'Asistență Clientă Prioritara',
      benefit2: '1.000.000 de tokeni/lună',
      benefit3: 'Traducere și Rezumat de Site Web',
      benefit4: '200 de Traduceri de Imagini',
      benefit5: 'Traducere și Rezumat Video',
      benefit6: '200 de traduceri PDF',
      btn: 'Începeți',
      recommendText: 'Cele mai populare',
    },
    proPlus: {
      benefit1: 'Suport Client Prioritar',
      benefit2: '3.000.000 de tokeni/lună',
      benefit3: 'Traducere și Rezumat de Website',
      benefit4: '500 de Traduceri de Imagini',
      benefit5: 'Traducere și Rezumat Video',
      benefit6: '500 de traduceri PDF',
      recommendText: 'Cel mai bun raport calitate-preț',
    },
    video: { summary: 'Rezumat video', translation: 'Traducere video' },
    web: {
      contrastiveTranslation: 'Traducere bilingvă',
      dictionaryTranslation: 'Traducere de selecție',
      hoverTranslation: 'Traducere prin hover',
      instantTranslation: 'Traducere Instantană',
      summary: 'Rezumat Pagină Web',
    },
    yearly: 'Anual',
  },
  privacy: {
    block1:
      'Noam („Noam”, „noi”, „al nostru” sau „ne”) respectă confidențialitatea dvs. și este angajat să protejeze orice informație pe care o obținem de la dvs. sau despre dvs. Această Politică de confidențialitate descrie practicile noastre în ceea ce privește colectarea sau utilizarea informațiilor personale provenind din utilizarea site-ului web, aplicațiilor și serviciilor noastre (împreună numite „Servicii”). Această Politică de confidențialitate nu se aplică conținutului pe care îl gestionăm în numele clienților cu produse de afaceri, cum ar fi API-ul nostru. Utilizarea acestor date este supusă Acordului cu clientul, care acoperă accesul la aceste produse și utilizarea lor.',
    block10:
      'Implementăm măsuri tehnice, administrative și organizaționale comerciale rezonabile pentru a proteja informațiile personale online și offline împotriva pierderii, utilizării necorespunzătoare, accesului neautorizat, dezvăluirii, modificării sau actelor ostile. Cu toate acestea, nicio transmisie prin internet sau email nu poate garanta securitate sau acuratețe complete. În special, emailurile trimise către noi sau de la noi pot fi nesigure. Prin urmare, ar trebui să fiți deosebit de atenți atunci când decideți ce informații să ne trimiteți prin serviciu sau email. În plus, nu suntem responsabili pentru nicio blocare a setărilor de confidențialitate sau a măsurilor de securitate în serviciu sau în setările de securitate sau măsurile de securitate ale site-urilor web ale terților. Vom păstra informațiile dvs. personale atâta timp cât este necesar pentru a vă oferi servicii sau pentru alte scopuri comerciale legitime, cum ar fi rezolvarea disputelor, motive de securitate și siguranță sau conformarea obligațiilor noastre legale. Durata de timp pentru care păstrăm informațiile personale va depinde de mai mulți factori, cum ar fi cantitatea, natura, sensibilitatea informațiilor, riscurile potențiale de utilizare neautorizată sau dezvăluire, scopurile pentru care procesăm informațiile și alte considerații cu caracter juridic obligatoriu.',
    block11:
      'Acest Politică de Confidențialitate poate fi actualizată periodic. Când o facem, vom publica o versiune actualizată pe această pagină,除非 legea aplicabilă prevede altfel.',
    block12:
      'Dacă aveți orice întrebări ne răspunse sau nelămuriri cu privire la această Politică de confidențialitate, vă rugăm să contactați serviciul de asistență al clienților. Email:',
    block2:
      'Collectăm următoarele informații personale („Informații personale”) referitoare la dvs.:',
    block3:
      'Informații furnizate de dvs.: Când creați un cont pentru a folosi serviciile noastre sau comunicați cu noi, colectăm informații personale după cum urmează:',
    block4:
      'Informații personale primite automat în urma utilizării serviciilor: Când accesați, folosiți sau interacționați cu serviciile, primim următoarele informații despre accesul, utilizarea sau interacțiunea dvs. („Informații tehnice”):',
    block5: 'Putem folosi informații personale în următoarele scopuri:',
    block6:
      'Rezumat sau Informații Deidentificate: Putem agrega sau deidentifica informațiile personale pentru a preveni reutilizarea lor în scopuri de identificare și putem folosi astfel de informații pentru a analiza eficacitatea serviciilor noastre, a le îmbunătăți și adăuga funcționalități, a efectua cercetări și pentru scopuri similare. În plus, putem analiza comportamentul general și caracteristicile utilizatorilor serviciului nostru și putem partaja informații agregate cu terți, publica astfel de informații agregate sau le putem pune la dispoziție în mod general. Putem colecta informații agregate prin intermediul serviciilor, prin intermediul cookie-urilor și prin alte mijloace descrise în această Politică de Confidențialitate. Vom păstra și folosi informațiile deidentificate în formă anonimă sau deidentificată și nu vom încerca să reidentificăm astfel de informații decât dacă este cerut de lege.',
    block7:
      'În anumite cazuri, putem furniza informațiile dvs. personale către terți fără a vă da un avertisment suplimentar, cu excepția cazurilor în care legea o exige:',
    block8:
      'În funcție de locația geografică, persoanele din Spațiul Economic European, Regatul Unit și din întreaga lume pot avea anumite drepturi statutare în ceea ce privește informațiile personale. De exemplu, aveți dreptul să:',
    block9:
      'Serviciul poate conține linkuri către alte site-uri web care nu sunt operate sau controlate de Noam, inclusiv servicii de social media („Site-uri web terțe”). Informațiile pe care le partajați cu Site-urile web terțe vor fi guvernate de politicile specifice de confidențialitate și termenii de serviciu ai Site-urilor web terțe, nu de această Politică de confidențialitate. Aceste linkuri sunt furnizate pentru conveniență și nu implică aprobarea sau recenzia acestor site-uri web. Pentru informații despre politicile lor de confidențialitate și termenii, contactați direct Site-urile web terțe.',
    subBlock1:
      'Informații despre cont: Când creați un cont pe platforma noastră, colectăm informații legate de contul dvs., inclusiv numele dvs., informațiile de contact, credentialele contului, informațiile despre cardul de plată și istoricul tranzacțiilor ("Informații despre cont").',
    subBlock10: 'Furnizarea, gestionarea, întreținerea și/sau analiza serviciilor;',
    subBlock11: 'Comunicând cu tine',
    subBlock12: ' Dezvoltarea de produse și servicii noi;',
    subBlock13:
      'Prevenirea fraudelor, activității criminale sau folosirii abuzive a serviciilor noastre, precum și protecția securității sistemelor noastre IT, arhitecturii și rețelelor;',
    subBlock14: 'Efectuarea transferurilor comerciale;',
    subBlock15:
      'Conformarea obligațiilor legale și a procedurilor juridice, protecția drepturilor noastre, a vieții private, securității sau proprietății, precum și ale celor ale afiliaților noștri, ale dvs. sau ale altor părți terțe.',
    subBlock16:
      'Furnizori și Proveďători de Servicii: Pentru a ne ajuta să îndeplinim nevoile operaționale ale afacerii și să executăm anumite servicii și funcții, putem furniza informații personale către furnizori și proveďători de servicii, inclusiv furnizori de servicii de găzduire, furnizori de servicii cloud, alți furnizori de servicii de tehnologie informației, software de comunicare prin email și furnizori de servicii de analiză web etc. Acești parteneri vor accesa, procesa sau stoca informații personale numai la direcția noastră în timpul îndeplinirii datoriei lor față de noi.',
    subBlock17:
      'Transferuri comerciale: Dacă participăm la tranzacții strategice, reorganizări, falimente, preluări în faliment sau trecerea serviciilor către un alt furnizor (împreună numite „Tranzacții”), informațiile tale personale și alte informații pot fi partajate cu părțile contrahente ale tranzacției și alte părți care asistă la Tranzacții în timpul auditului de due diligence și transferate ca parte a Tranzacțiilor, împreună cu alte active, către o companie succesoară sau afiliată.',
    subBlock18:
      'Exigențe legale: Putem partaja informațiile dvs. personale cu autoritățile guvernamentale, colegii din industrie sau alți terți, inclusiv informațiile despre interacțiunea dvs. cu serviciile noastre, (1) dacă este necesar conform legii sau dacă considerăm că o astfel de acțiune este necesară pentru a respecta obligațiile legale; (2) pentru a proteja și apăra drepturile sau proprietatea noastră; (3) dacă stabilim unilateral că există o încălcare a termenilor, politicilor sau legilor noastre; (4) pentru a detecta sau preveni fraudele sau alte activități ilegale; (5) pentru a proteja produsele noastre, angajații sau utilizatorii, precum și siguranța publică, securitatea, integritatea; sau (vi) pentru a apăra împotriva răspunderii legale.',
    subBlock19:
      'Accesați informațiile dvs. personale și informațiile despre modul în care acestea sunt procesate.',
    subBlock2:
      'Când folosiți serviciile noastre, colectăm informații personale din intrările dvs., încărcările de fișiere sau feedback-ul furnizat către noi („Conținut”).',
    subBlock20: 'Cererea de ștergere a informațiilor dvs. personale din înregistrările noastre.',
    subBlock21: 'Corectați sau actualizați informațiile dvs. personale.',
    subBlock22:
      'Transferați informațiile dvs. personale către o parte terță (portabilitate a datelor).',
    subBlock23: 'Limitați modul în care procesăm informațiile dvs. personale.',
    subBlock24:
      'Retrageți consimțământul dvs. — în cazul în care ne bazăm pe consimțământul ca bază juridică pentru prelucrare, puteți retrage consimțământul dvs. în orice moment.',
    subBlock25: 'Contestați modul în care procesăm informațiile dvs. personale.',
    subBlock26: 'Îmbunătățirea serviciilor noastre și efectuarea cercetărilor;',
    subBlock3:
      'Informații de comunicare: Dacă ne trimiteți mesaje, vom colecta numele dvs., informațiile de contact și conținutul mesajelor dvs. ("Informații de comunicare").',
    subBlock4:
      'Informații despre rețelele sociale: Avem pagini pe site-uri de rețele sociale precum Instagram, Facebook, Medium, Twitter, YouTube și LinkedIn. Când interacționați cu paginile noastre de rețele sociale, colectăm informațiile personale pe care alegeți să ni le furnizați, cum ar fi detaliile de contact ("Informații sociale"). În plus, companiile care găzduiesc paginile noastre de rețele sociale pot ne furniza informații agregate și analize despre activitățile noastre de rețele sociale.',
    subBlock5:
      'Date de log: Informații trimise automat de browserul dvs. atunci când folosiți serviciile noastre. Datele de log includ adresa dvs. de Protocol Internet (IP), tipul și setările browserului, data și ora cererilor dvs. și modul în care interacționați cu site-ul nostru web.',
    subBlock6:
      'Date de utilizare: Putem colecta automat informații despre utilizarea serviciului de către dvs., cum ar fi tipurile de conținut pe care le vizionați sau cu care interacționați, funcțiile pe care le folosiți, acțiunile pe care le întreprindeți, precum și fusul orar, țara, data și ora accesului, agentul de utilizator și versiunea acestuia, tipul de dispozitiv computer sau mobil și conexiunea dvs. la computer.',
    subBlock7:
      'Informații despre dispozitiv: Acestea includ numele dispozitivului, sistemul de operare, identificatorul dispozitivului și browserul pe care îl folosiți. Informațiile colectate pot depinde de tipul de dispozitiv pe care îl folosiți și de setările acestuia.',
    subBlock8:
      'Cookie-uri: Folosim cookie-uri pentru a opera și gestiona serviciile noastre și pentru a vă îmbunătăți experiența. Un „cookie” este informație trimisă de un site web pe care îl vizitați către browserul dvs. Puteți seta browserul să accepte toate cookie-urile, să respingă toate cookie-urile sau să vă notifice când un cookie este furnizat, astfel încât să puteți decide dacă îl acceptați sau nu de fiecare dată. Cu toate acestea, refuzarea cookie-urilor poate împiedica utilizarea sau poate afecta negativ afișarea sau funcționalitatea anumitor zone sau caracteristici ale site-ului web. Pentru mai multe informații despre cookie-uri, vă rugăm să vizitați All About Cookies.',
    subBlock9:
      'Analitice: Putem folosi diverse produse online de analitice care utilizează cookie-uri pentru a ne ajuta să analizăm modul în care utilizatorii folosesc serviciile noastre și pentru a îmbunătăți experiența dvs. atunci când folosiți serviciile.',
    subTitle1: 'Informațiile personale pe care le colectăm',
    subTitle2: 'Cum folosim informațiile personale',
    subTitle3: 'Divulgarea Informațiilor Personale',
    subTitle4: 'Drepturile tale',
    subTitle5: 'Linkuri către alte site-uri web',
    subTitle6: 'Securitatea și Retenția Informațiilor',
    subTitle7: 'Modificarea Politicii de Confidențialitate',
    subTitle8: 'Cum să ne contactați',
    title: 'Politica de confidențialitate',
    updateTime: 'Actualizat: 15 martie 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Acceptă toate',
    text: 'Pentru a vă îmbunătăți experiența, folosim cookie-uri pentru a personaliza conținutul și serviciile.',
    title: 'Acest site web folosește cookie-uri',
  },
  slogen: 'Asistentul AI cel mai simplu',
  stripe: {
    contact: 'Contactați-ne la contact@noam.tools pentru orice întrebări!',
    fail: {
      btn: 'Reîncercați',
      text1: 'Nu am putut procesa plata dvs.',
      text2: 'Verificați conexiunea și încercați din nou.',
      title: 'Plata a eșuat',
    },
    succ: {
      btn: 'Să mergem',
      text1: 'Bine ați venit la Noam',
      text2: 'să începem!',
      title: 'Felicitări',
    },
  },
  terms: {
    block1: 'Vă mulțumim că ați folosit Noam!',
    block10:
      '(a) Taxe și facturare. Veți plăti toate taxele („Taxe”) în conformitate cu prețurile și condițiile de pe pagina de prețuri aplicabilă sau așa cum au fost stabilite în scris între noi. Ne rezervăm dreptul de a corecta erorile sau greșelile de preț chiar dacă am emis facturi sau am primit plată. Veți furniza informații complete și precise de facturare, inclusiv o metodă de plată validă și autorizată. Vom debită metoda dvs. de plată periodic, așa cum a fost stabilit, dar putem modifica data de facturare în mod rezonabil. Autorizați Noam, afiliații săi și procesatorii terți de plăți să debiteze metoda dvs. de plată. Dacă plata dvs. eșuează, vă vom furniza o notificare scrisă și putem suspenda accesul la Serviciu până la primirea plății. Cu excepția cazurilor prevăzute altfel în acest acord, plățile sunt neîntoarcibile.',
    block11:
      '(b) Taxe. Cu excepția cazurilor în care se specifică altfel, Taxele nu includ nicio taxă federală, de stat, locală sau străină, taxe vamale sau evaluări similare („Taxe”). Sunteți responsabil pentru toate Taxele asociate cu achizițiile dvs., excluzând Taxele bazate pe venitul nostru net, pentru care vă vom emite factură. Sunteți de acord să plătiți prompt astfel de Taxe și să ne furnizați declarații de confidențialitate legal valide și să obțineți consimțământurile necesare pentru gestionarea unor astfel de date, și vă garantați că gestionați astfel de date în conformitate cu legea aplicabilă.',
    block12:
      '(c) Modificări ale prețurilor. Putem modifica prețurile noastre prin notificarea dvs. prin contul dvs. și/sau website-ul nostru. Creșterile de preț vor intra în vigoare imediat după postare. Orice modificări ale prețurilor vor fi aplicabile Taxelor pentru contul dvs. după data de efectivitate a modificării.',
    block13:
      '(d) Contestații și plăți întârziate. Dacă doriți să contestați orice Taxe sau Taxe, vă rugăm să contactați contact@noam.tools în termen de treizeci (30) de zile de la data facturii.',
    block14:
      '(e) Utilizare gratuită. Nu puteți crea conturi multiple pentru a obține credite gratuite. Dacă stabilim că nu folosiți creditele gratuite în bunăcredință, putem să vă facturăm taxe standard sau să încetăm furnizarea accesului la Serviciu.',
    block15:
      'Confidențialitate. Puteți avea acces la informații confidențiale ale Noam. Puteți folosi informațiile confidențiale numai așa cum este permis sub aceste termeni, în scopul utilizării Serviciului. Nu puteți dezvălui informații confidențiale niciunui partener terț și veți proteja informațiile confidențiale într-o manieră nu mai puțin protectoare decât cea în care protejați propriile informații confidențiale similare, cel puțin cu îngrijorare rezonabilă. Informațiile confidențiale sunt informații nepubliche designatelor ca confidențiale de către Noam sau care ar trebui tratate în mod rezonabil ca confidențiale în circumstanțele date, inclusiv software, specificații și alte informații de afaceri nepubliche. Informațiile confidențiale nu includ informațiile care: (1) devin disponibile în mod general publicului fără că voi fi vinovat; (2) ați avut în posesia voastră fără nicio obligație de confidențialitate înainte de a le primi sub aceste termeni; (3) sunt dezvăluite în mod legal vouă de către un partener terț fără nicio obligație de confidențialitate; sau (4) sunt dezvoltate independent de voi fără a folosi informațiile confidențiale. Puteți dezvălui informații confidențiale dacă este solicitat de lege, instanță sau alt ordin guvernamental, dar trebuie să oferiți o notificare scrisă prealabilă Noam într-o manieră rezonabilă și, în măsura posibilului, să faceți eforturi rezonabile pentru a limita domeniul de aplicare al dezvăluirii, inclusiv ajutându-ne să ne opusim cererilor de dezvăluire.',
    block16:
      '(b) Securitate. Trebuie să implementați măsuri rezonabile și adecvate pentru a proteja accesul și utilizarea Serviciului. Dacă descoperiți orice vulnerabilități sau încălcări legate de utilizarea Serviciului, trebuie să contactați imediat Noam și să furnizați detalii despre vulnerabilitatea sau încălcarea.',
    block17:
      '((c) Procesarea datelor personale. Dacă folosiți Serviciul pentru a procesa date personale, trebuie să furnizați declarații de confidențialitate legale suficient de solide și să obțineți consimțământurile necesare pentru procesarea acestor date, și vă garantați că gestionați astfel de date în conformitate cu legea aplicabilă.',
    block18:
      'Terminare; Suspendare. Aceste termeni vor intra în vigoare de la prima folosință a Serviciului și vor rămâne în vigoare până la terminare. Puteți termina acești termeni în orice moment și din orice motiv prin încetarea utilizării Serviciului și Conținutului. Noi putem termina acești termeni cu preaviz înainte, din orice motiv. Noi putem termina imediat acești termeni prin notificarea dvs. dacă încălciti în mod material Secțiunea 2 (Cerințe de utilizare), Secțiunea 5 (Confidențialitate, Securitate și Protecție a datelor), Secțiunea 8 (Rezolvare a争端elor) sau Secțiunea 9 (Termeni generali), sau dacă relația noastră cu orice furnizor de tehnologie terță parte dincolo de controlul nostru se modifică, sau pentru conformitate cu legea sau cererile guvernamentale. Noi putem suspenda accesul dvs. la Serviciu dacă nu respectați acești termeni, sau dacă utilizarea dvs. prezintă un risc de securitate pentru noi sau pentru orice terță parte, sau dacă suspectăm că utilizarea dvs. este frauduloasă sau poate expune pe noi sau pe orice terță parte la răspundere.',
    block19:
      '(b) Efectele încetării. La încetare, veți înceta utilizarea Serviciului și veți returna sau distruge prompt orice informație confidențială așa cum vi se indică de către noi. Dispozițiile acestor termeni care, prin natura lor, ar trebui să rămână în vigoare după încetare sau expirare, inclusiv dar fără a se limita la Secțiunile 3 și 5-9, vor rămâne în vigoare.',
    block2:
      'Aceste Termeni de Utilizare se aplică utilizării serviciilor Noam, inclusiv interfețelor noastre de programare a aplicațiilor, software-ului, instrumentelor, serviciilor pentru dezvoltatori, datelor, documentației și site-ului web (denumite colectiv „Servicii”). Prin utilizarea Serviciilor noastre, sunteți de acord să respectați acești termeni. Politica noastră de confidențialitate explică modul în care colectăm și utilizăm informațiile personale.',
    block20:
      '(a) Indemnizație. Veți apăra, indemniza și păstra nevinovați pe noi, afiliații noștri și personalul nostru față de orice reclamații, pierderi și cheltuieli (inclusiv taxele avocaților) care rezultă din sau sunt legate de utilizarea dvs. a Serviciului, inclusiv Conținutul dvs., utilizarea dvs. a produselor sau serviciilor legate de Serviciu și încălcarea dvs. a acestor termeni sau a legii aplicabile.',
    block21:
      '(b) Exonerări de răspundere. Serviciul este furnizat „așa cum este”. În măsura permisă de lege, noi, afiliații noștri și licențiatorii nu facem nicio reprezentare sau garanție de orice fel în legătură cu Serviciul și nu oferim garanții, inclusiv dar nu limitat la garanțiile de comerțializabilitate, adecvare pentru un scop particular, calitate satisfăcătoare, neinfracțiune și plăcere liniștită, precum și orice garanție care rezultă din cursul afacerilor sau utilizării comerțiale. Nu garantăm că Serviciul va fi ne întrerupt, exact sau lipsit de erori, sau că orice Conținut va fi securizat, nu va fi pierdut sau nu va fi modificat.',
    block22:
      '(c) Limitarea răspunderii. Nici noi, nici afiliații noștri, nici licențiatorii noștri nu vor fi responsabili pentru daune indirecte, accidentale, speciale, consecvente sau punitive, inclusiv pierderea profiturilor, pierderea reputației, pierderea utilizării, pierderea datelor sau alte pierderi necorporale, chiar dacă am fost avertizați cu privire la posibilitatea unor astfel de daune. Conform acestor termeni, răspunderea noastră totală nu va depăși taxele pe care le-ați plătit pentru Serviciu în cele douăzeci și patru (12) luni precedente prezentării reclamării sau o sută de dolari americani ($100), în funcție de care este mai mare. Limitele din această secțiune se aplică în măsura maximă permisă de legea aplicabilă.',
    block23:
      'Termenii și utilizarea Serviciilor tale sunt guvernate de legile Statelor Unite, cu excepția regulilor de conflict de legi ale SUA. Utilizarea Aplicației tale poate fi, de asemenea, supusă altor legi locale, statale, naționale sau internaționale. Orice acțiune sau procedură juridică referitoare la acești Termeni va fi prezentată exclusiv în instanțele Statelor Unite, iar tu accepti să te supui jurisdicției personale ale acestor instanțe.',
    block24:
      'Relația între Părți. Noam și dumneavoastră sunteți contractori independenți, și nicio parte nu are puterea de a reprezenta sau obliga cealaltă parte sau de a asuma obligații în numele celeilalte părți fără consimțământul prealabil scris al celeilalte părți.',
    block25:
      '(b) Utilizarea brandului. Nu puteți folosi numele, logo-urile sau marcile comerciale ale Noam sau ale vreunui dintre afiliații săi fără acordul nostru prealabil în scris.',
    block26:
      'Dacă orice prevedere a acestor termeni este considerată nevalabilă, ilegală sau inexecutabilă, prevederile rămase vor rămâne în vigoare și efect complete.',
    block3:
      'Dacă sunteți sub vârsta de 18 ani, trebuie să obțineți permisiunea părinților sau a tutoriilor legale pentru a folosi Serviciul. Dacă folosiți Serviciul în numele unei alte persoane sau entități, trebuie să fi autorizat să acceptați aceste termeni în numele lor. Trebuie să furnizați informații exacte și complete pentru a vă înregistra un cont. Nu puteți furniza credentialele de acces sau contul cu cineva din afara organizației dvs., și sunteți responsabil pentru toate activitățile efectuate folosind credentialele dvs.',
    block4:
      '(a) Utilizarea Serviciului. Puteți accesa Serviciul în conformitate cu aceste termeni, iar noi vă acordăm un drept non-exclusiv de a utiliza Serviciul. Când utilizați Serviciul, veți respecta aceste termeni și toate legile aplicabile. Noi și afiliații noștri deținem toate drepturile, titlurile și interesele în Serviciu.',
    block5:
      '(b) Feedback. Întrebăm feedback, comentarii, idei, sugestii și îmbunătățiri. Dacă furnizați orice astfel de conținut, îl putem folosi fără nicio restricție și fără a vă oferi compensație.',
    block6:
      '(c) Restricții. Nu puteți: (1) folosi Serviciul într-o manieră care încălcă, însuși sau violeze orice drepturi ale altora; (2) efectua reverse engineering, decompila, dezasambla, traduce sau încerca în orice alt mod să descoperiți codul sursă sau componentele subiacente ale modelelor, algoritmilor și sistemelor Serviciului (cu excepția cazului în care astfel de restricții sunt interzise de lege aplicabilă); (3) folosi rezultatul Serviciului pentru a dezvolta modele care concurează cu Noam; (4) extrage date sau rezultate din Serviciu folosind orice metode automate sau de programare, cu excepția cazului în care acestea sunt permise prin API, inclusiv scraping, colectare web sau extragere de date web; (5) reprezenta rezultatul Serviciului ca fiind generat artificial atunci când nu este așa, sau încălca în orice alt mod politicile noastre de utilizare; (6) cumpăra, vinde sau transfera chei API fără acordul nostru prealabil; sau (7) ne furniza orice informații personale ale copiilor sub vârsta de 13 ani sau vârsta aplicabilă de consimțământ digital. Veți respecta orice limite de rată și alte cerințe din documentația noastră.',
    block7:
      '(d) Servicii terțe. Orice software, servicii sau alte produse terțe asociate cu Serviciul sunt guvernate de propriile sale termeni, iar noi nu suntem responsabili pentru produsele terțe.',
    block8:
      '(a) Conținutul dvs. Puteți furniza date de intrare („Intrare”) serviciului și primiți rezultate („Ieșire”) generate și returnate pe baza Intrare (denumite colectiv „Conținut”). între părți, și în măsura permisă de legea aplicabilă, dețineți toate datele de intrare. Noam poate folosi Conținutul pentru a furniza și menține Serviciul, a se conforma legilor aplicabile și a executa politicile noastre. Sunteți responsabil pentru Conținut, inclusiv pentru asigurarea că nu încălcă nicio lege aplicabilă sau aceste termeni.',
    block9:
      '(b) Precizie. Inteligența artificială și învățarea automată sunt domenii de cercetare care evoluează rapid. Ne străduim continuu să îmbunătățim serviciul nostru pentru a-l face mai precis, fiabil, securizat și benefic. Având în vedere natura probabilistică a învățării automate, utilizarea serviciului nostru poate duce în unele cazuri la rezultate incorecte, care nu reflectă accurate persoane, locuri sau fapte reale. Ar trebui să evaluați în mod adecvat precizia oricărui rezultat bazându-vă pe cazul dvs. de utilizare, inclusiv prin verificarea manuală a rezultatelor.',
    subTitle1: 'Înregistrare și Acces',
    subTitle10: 'Divizibilitate',
    subTitle2: 'Cerințe de utilizare',
    subTitle3: 'Conținut',
    subTitle4: 'Taxe și Plată',
    subTitle5: 'Confidențialitate, Securitate și Protecție a Datelor',
    subTitle6: 'Termen și încetare',
    subTitle7: 'Indemnizație; Exonerări de răspundere; Limitare a răspunderii',
    subTitle8: 'Legislatie guvernanta si Competenta judiciara',
    subTitle9: 'Termeni Generali',
    title: 'Termeni de Serviciu',
    updateTime: 'Actualizat: 15 martie 2024',
  },
  trialModal: {
    btn: 'Începeți acum (Doar 0,99 $)',
    chat: 'ChatPDF',
    desc1: 'După perioada de proba, veți fi facturat cu o taxă anuală de 180 USD',
    desc2: 'Anulează oricând',
    focus: 'Concentrarea',
    hover: 'Traducere la trecerea cursorului',
    image: 'Traducere de imagini',
    installBtn: 'Instalează acum pentru a primi cadoul tău',
    memo: 'Gestionarea favoritei',
    pdf: 'Traducere paralelă PDF',
    realtime: 'Traducere instantanee',
    select: 'Traducere a selecției de cuvinte',
    title: 'Cadou de bun venit',
    trialText: 'Proba de 7 zile',
    video: 'Traducere video',
    videoSummary: 'Rezumat video',
    web: 'Traducere paralelă',
    webSummary: 'Rezumat web',
  },
  upgradeModal: {
    btn: 'Actualizează acum',
    chat: { free: 'Ați atins limita ChatPDF', pro: 'Ați atins limita ChatPDF pentru acest lună' },
    contactStr:
      'Vă rugăm să așteptați următoarea resetare sau să ne contactați la adresa contact@noam.tools.',
    limitAlertStr: 'Ați atins limita planului gratuit. Actualizați pentru a continua.',
    more: 'Vezi Planurile',
    pageLimit: { free: 'Ați atins limita de pagini PDF' },
    title: 'Amintire',
    upgradeAlertStr: 'Ați atins limita planului gratuit. Actualizați pentru a continua.',
    upload: {
      free: 'Ați atins limita de traducere PDF',
      pro: 'Ați atins limita de traducere PDF pentru acest lună',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Alăturați-vă acum',
      label: 'Beneficii pentru utilizator nou:',
      remain: 'Doar 30 rămase',
      text: 'Doar 100 de locuri disponibile! Ia-ti locul acum!',
    },
  },
  aiPdfTranslator: {
    title: 'Traducător gratuit AI de PDF: Traducerea PDF-urilor cu comparare în orice limbă',
    desc: 'Traduceți cu ușurință fișiere PDF în orice limbă cu AI. Comparați textul original și cel tradus unul lângă celălalt, rapid și gratuit.',
    keywords: 'GPT-4、Asistent AI、Traducere、Rezumat、Concentrare、ChatPDF、Memoriu、eficiență',
    sourceToTarget: {
      title: 'Instrument gratuit de traducere PDF: traduceți {{source}} în {{target}} gratuit',
      desc: 'Traduceți fișierele PDF ale dvs. din orice limbă sursă în limba preferată gratuit. Traducere PDF rapidă, precisă și sigură, puternizată de AI avansat.',
    },
    headerIntroduce: {
      title: 'Noam: Mai mult decât doar traducere online',
      introduce1: {
        title: 'Noam · Cititor PDF',
        desc: '✨Traducere side-by-side + Întrebări și Răspunsuri AI. Traduceți rapid și precis fișierele PDF în limba dvs. țintă. Puneți întrebări libere despre conținut pentru a obține o înțelegere mai profundă a fișierelor dvs. PDF.',
      },
      introduce2: {
        title: 'Noam · Extensie de traducere side-by-side',
        desc: '👏Resolvați toate nevoile dvs. de traducere a paginilor web:',
        detail1: { title: 'Traducere Pagină Web:', desc: 'Vizualizare bilingvă side-by-side' },
        detail2: { title: 'Traducere de cuvânt:', desc: 'Traducere rapidă cu un click' },
        detail3: {
          title: 'Traducere Instantană:',
          desc: 'Traduceți cuvinte sau propoziții instantaneu.',
        },
        detail4: { title: 'Traducere imagine:', desc: 'Înlocuiți imaginile cu cele traduse.' },
        detail5: {
          title: 'Traducere video:',
          desc: 'Subtitrări bilingve pentru o vizionare mai bună.',
        },
        footer:
          'Experimentați mai multe funcții de citire powerizate de AI pentru o traducere mai inteligentă!',
      },
    },
    subtitle: 'Traducere PDF Online Gratuit',
    introduce: {
      module1: {
        detail1: {
          title: 'Traducere PDF în timp real Side-by-Side',
          desc1:
            'Afișați instantaneu conținutul original și tradus într-o prezentare sincronizată, side-by-side',
          desc2: 'Comparați ușor ambbele versiuni cu derulare sincronizată',
          desc3: 'Păstrați formatarea identică pentru o experiență de citire consistentă',
        },
        detail2: {
          title: 'Alinierea și verificarea precisă a conținutului',
          desc1: 'Aliniere perfectă între textul sursă și cel tradus pentru verificare ușoară',
          desc2: 'Fiecare segment de conținut se potrivește exact între cele două versiuni',
          desc3:
            'Identificați și rezolvați rapid discrepanțele de traducere pentru rezultate fiabile',
        },
      },
      module2: {
        detail1: {
          title: 'Mai multe modele avansate de AI pentru traducere precisă',
          desc1:
            'Selectați din modelele AI de top pentru a se potrivi cerințelor dvs. de traducere',
          desc2: 'Asigurați rezultate optime pentru diverse tipuri de documente și industrii',
          desc3: 'Opțiuni de model flexibile oferă soluții adaptate pentru fiecare scenariu',
        },
        detail2: {
          title: 'Traducere avansată cu AI pentru orice tip de conținut',
          desc1:
            'Modelul nostru puternic de inteligență artificială garantează o precizie ridicată și înțelegerea limbajului natural',
          desc2: 'Gestionează documente tehnice, academice și creative cu ușurință',
          desc3: 'Oferă rezultate fiabile pentru toate nevoile tale de traducere',
          desc4: 'Adaptare inteligentă la diferite tipuri de conținut pentru performanță optimă',
        },
      },
      module3: {
        detail1: {
          title: 'Interacțiune Inteligentă cu Documente',
          desc1: 'Conversați cu fișierele dvs. PDF și prezentări în mod ușor, folosind AI avansat',
          desc2:
            'Puneți întrebări instantanee despre conținutul documentului și primiți răspunsuri precise',
          desc3: 'Generați rapid rezumate concise pentru documente lungi',
        },
        detail2: {
          title: 'Analiză Profunda a Conținutului și Integrare Fără Probleme',
          desc1:
            'Extrage informații cheie și analizează date complexe cu înțelegere puternizată de AI',
          desc2: 'Obțineți perspective asupra materialelor tehnice, academice sau creative',
          desc3:
            'Se integrează perfect cu Traducătorul nostru PDF pentru o soluție completă de gestionare a documentelor',
        },
      },
      module4: {
        detail1: {
          title: 'Peste Traducerea PDF: Soluție Integrată de Traducere a Paginii Web',
          desc: 'Descoperiți extensia noastră puternică de traducere side-by-side, concepută pentru orice scenariu de citire online.',
          desc1:
            'Traducere pagină web: Bucură-te de conținut bilingv cu o vizualizare sincronizată side-by-side',
          desc2:
            'Traducere de cuvinte: Traducerea instantanee a cuvintelor evidențiate cu un singur clic',
          desc3:
            'Traducere Instantană: Traducerea oricărui text sau propoziție imediat pentru înțelegere rapidă',
          desc4: 'Traducere imagine: Înlocuiește automat imaginile originale cu versiunile traduse',
          desc5:
            'Traducere video: Vizionați videoclipuri cu subtitrări bilingve pentru o experiență îmbunătățită',
        },
      },
    },
    question: {
      title: 'Întrebări frecvente',
      answer1: {
        title: 'Este gratuit să folosiți Noam PDF Translator pentru traducerea PDF-urilor?',
        content:
          'Da, puteți traduce fișiere PDF gratuit cu Sider PDF Translator! Oferim o cotă gratuită de 5.000 de tokeni, care este suficientă pentru a traduce majoritatea documentelor PDF întâlnite în mod obișnuit pe piață. Dacă aveți nevoie să traduceți fișiere mai mari sau aveți nevoie de funcții avansate, puteți alege să vă actualizați la planurile noastre premium pentru capabilities even more.',
      },
      answer2: {
        title: 'Cât de precis este Traducătorul PDF Noam?',
        content:
          'Traducătorul Noam PDF oferă traduceri extrem de precise prin utilizarea tehnologiei AI avansate și prin înțelegerea profundă a contextului documentelor dvs. Deși nicio traducere automată nu este perfectă, afișarea noastră laterală permiteți să revizuiți și să rafinați ușor fiecare traducere, garantând că rezultatul final îndeplinește așteptările dvs. privind calitatea. Experimentați o traducere PDF fiabilă și precisă cu Noam.',
      },
      answer3: {
        title: 'Pot traduce fișiere PDF scanate?',
        content:
          'Da, puteți traduce fișiere PDF scanate cu tehnologia noastră integrată de OCR (Recunoaștere Optică a Caracterelor). Sistemul nostru extrage automat textul din documentele scanate și PDF-urile bazate pe imagini, apoi traduce conținutul pentru dvs. Acest lucru asigură că chiar și PDF-urile non-editabile sau care conțin doar imagini pot fi traduse cu precizie.',
      },
      answer4: {
        title: 'Cât timp durează traducerea?',
        content:
          'Traducerea este rapidă și eficientă – majoritatea documentelor sunt procesate în câteva secunde până la câțiva minute, în funcție de lungimea și complexitatea lor. De exemplu, un fișier PDF standard de 10 pagini durează de obicei mai puțin de 2 minute să fie tradus. Bucurați-vă de timpi rapidi de finalizare pentru toate nevoile dvs. de traducere a documentelor!',
      },
      answer5: {
        title: 'Pot păstra vizualizarea side-by-side pentru citire?',
        content:
          'Da, întotdeauna poți citi documentele tale unul lângă altul. Această afișare permite compararea ușoară a conținutului original și al celui tradus, asigurând o experiență de citire fluidă și eficientă.',
      },
    },
    freeTrial: 'Evaluare gratuită',
    toLanguage: { title: 'Perechi de traducere AI PDF', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Caracteristici',
      blog: 'Blog',
      pricing: 'Prețuri',
      faq: 'Întrebări frecvente',
      button: 'Traducere acum',
    },
    hero: {
      upload: {
        desc: 'sau trageți și plasați',
        title: 'Încărcați PDF-ul dvs.',
        max: 'Max',
        highlight: 'Click pentru a naviga',
      },
      title: 'Traducător gratuit de PDF',
      to: 'către',
      pill: 'Traducător PDF puternic cu AI',
      desc: 'Traduceri instantanee și precise care păstrează layout-ul original. Noam AI acceptă OCR și vizualizări side-by-side.',
      model: 'GPT-4 & Claude',
      translated: 'Tradus de Noam',
      support: 'Suport OCR',
      free: 'Proba gratuită',
      complete: 'Traducere finalizată',
    },
    ticker: {
      pdf: 'Traducere PDF',
      ocr: 'Tehnologia OCR',
      multi: 'Multi-Lingvistic',
      format: 'Menținerea formatului',
      side: 'Împreună',
      chat: 'Conversație cu PDF',
      web: 'Traducere web',
      secure: 'Securizat și Privat',
    },
    comparison: {
      bad: {
        title: 'Traducere standard',
        head: 'Formatare și context pierdute',
        text1: 'Eroare: Layout defect. Imagini plasate incorect.',
        text2:
          'Textul se suprapune și fonturile sunt inconsistente. Dificil de citit și neprofesionist...',
      },
      dump: { title: 'Extragere de text simplu' },
      good: {
        title: 'Traducere AI Noam',
        sub: 'Formatare Perfectă, Conștient de Context',
        tag: 'Rezultat Perfect',
      },
      title: 'De ce alegeți Noam AI?',
      desc: 'Începeți să nu mai vă luptați cu traducerea prin copiere-încolare. Experimentați diferența dintre instrumentele standard și traducerea noastră inteligente bazată pe context, puternizată de AI.',
    },
    showcase: {
      kicker: 'DOCUMENTE SUPORTATE',
      title2: 'Orice limbă',
      title1: 'Orice Document',
      note: 'Gestionați documente tehnice, academice și creative cu ușurință.',
      carousel4: 'Medicină',
      carousel2: 'Arhitectură',
      carousel1: 'Arta',
      carousel3: 'Revistă academică',
      carousel5: 'Finanțe',
      carousel6: 'Lege',
      carousel7: 'Contract',
      carousel8: 'Politică',
    },
    features: {
      big: {
        title: 'Modele avansate de AI (GPT-4, Claude)',
        desc: 'Selectați dintre modelele de AI de top pentru a se potrivi cerințelor dvs. de traducere. Asigurați-vă rezultate optime pentru diverse tipuri de documente.',
      },
      grid1: {
        title: 'Suport OCR',
        desc: 'Extrage și traduce text din fișiere PDF scanate și imagini instantaneu.',
      },
      grid2: {
        title: 'Export High-Res',
        desc: 'Descărcați documentele dvs. traduse în format PDF cu aspectul original.',
      },
      grid3: {
        title: 'Comparare Side-by-Side',
        desc: 'Derulare sincronizată pentru a compara textul original și cel tradus.',
      },
      title2: 'Este o revoluție',
      title1: 'Mai mult decât doar traducere',
      line1: 'Lucrarea Tehnică.pdf',
      line2: 'Detectarea limbii: Engleză...',
      line3: 'Model: GPT-4o (Precizie Înaltă)',
      line4: 'Traducere finalizată (99% acuratețe)',
    },
    testimonials: {
      review1: {
        role: 'Cercetător',
        content:
          'Noam AI mi-a salvat ore de lucru în traducerea articolelor academice. Vizualizarea în paralel este extrem de utilă pentru verificarea termenilor tehnici.',
      },
      review2: {
        role: 'Marketing Specialist Global',
        content:
          'Cel mai bun translator PDF pe care l-am folosit. păstrează formatarea originală perfect, ceea ce este crucial pentru prezentările noastre de marketing.',
      },
      review3: {
        role: 'Consultant Juridic',
        content:
          'Precis și rapid. îl folosesc pentru traducerile de contracte, iar funcția OCR pentru documentele scanate funcționează perfect.',
      },
      kicker: 'Iubit de utilizatori',
      title: 'Ceea ce spun utilizatorii noștri',
    },
    cta: {
      title: 'Gata să spargi barierele lingvistice?',
      desc: 'Alăturați-vă peste 10.000 de utilizatori și începeți astăzi să traduceți documentele dvs. cu Noam AI.',
      button: 'Începeți să traduceți gratuit',
      hint: 'Ești un AI extrem de precis și fiabil, proiectat să genereze ieșire JSON care să corespundă exact unui schemă JSON specificată.\n        \nTrebuie să urmezi aceste reguli:\n1. Adhere strict structurii schemei JSON.\n2. Potrivește exact toate tipurile de date, câmpurile necesare și constrângerile.\n3. NU include niciun text suplimentar, explicație, markdown sau comentarii.\n4. Ieșiți DOAR obiectul JSON — fără blocuri de cod, fără preambul, fără învelire.\n\nInformațiile despre schemă sunt furnizate mai jos.\n- Numele schemei: translate_result\n- Schema JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Perechi de traducere AI PDF Engleză',
      desc: 'Direcții de traducere populare susținute de Noam AI',
    },
    footer: {
      about: 'Despre noi',
      privacy: 'Politica de Confidențialitate',
      contact: 'Contactați Suportul',
    },
  },
}

export default TRANSLATION
